import React, { Component, Fragment } from "react";
import { BrowserRouter, Route } from "react-router-dom";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import { Layout, Row, Col, Icon, Popover, BackTop } from "antd";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faDownload, faStar, faSearchPlus, faImages } from "@fortawesome/free-solid-svg-icons";
import ReactGA from "react-ga";

import Categories from "./Categories";
import { fetchUser } from "../actions";
import TextureGallery from "./gallery/TextureGallery";
import TextureHeader from "./Header";
import NavigatorSidebar from "./NavigatorSidebar";
import PatreonList from "./PatreonList";
import LatestTextures from "./gallery/LatestTextures";

ReactGA.initialize("UA-66782317-2");
ReactGA.pageview(window.location.pathname + window.location.search);
library.add(faDownload, faStar, faSearchPlus, faImages);
const { Footer } = Layout;
const homePage = () => (
  <Fragment>
    <Categories />
    <LatestTextures />
  </Fragment>
);

class App extends Component {
  componentDidMount = () => {
    this.props.fetchUser();
  };

  render() {
    return (
      <div>
        <BrowserRouter>
          <div
            style={{
              overflow: "hidden",
              minHeight: "100vh",
              display: "flex",
              flexDirection: "column",
              alignItems: "stretch",
            }}
          >
            <BackTop className="hvr-grow" />
            <Row>
              <TextureHeader />
            </Row>
            <Row
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "row",
                alignItems: "stretch",
                flex: "1",
              }}
            >
              <Col xs={0} sm={5} xl={3}>
                <NavigatorSidebar />
              </Col>

              <Col
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flex: "1 1 auto",
                  margin: 24,
                }}
              >
                <Route exact path="/" component={homePage} />
                <Route path="/category/:category/:id/:subcategories?" component={TextureGallery} />
                <Route path="/textures/:textures/:id" component={TextureGallery} />
                <Route path="/search" component={TextureGallery} />
                <Route exact path="/contribute" component={TextureUpload} />
                <Route exact path="/admin" component={Admin} />
                <Route exact path="/account" component={Account} />
              </Col>
            </Row>
            <Row style={{ textAlign: "center" }}>
              <Footer
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <Popover
                  placement="topRight"
                  content={
                    <span style={{ color: "#212121" }}>
                      All content on this website belongs to the public domain. (CC0)
                    </span>
                  }
                >
                  <img
                    alt="Public Domain icon"
                    className="hvr-grow"
                    style={{ height: "5em", width: "auto", cursor: "pointer" }}
                    src="https://d1wumrtbuo797i.cloudfront.net/cc0.svg"
                  />
                </Popover>

                <PatreonList />
                <div>
                  <a target="_blank" href="http://twitter.com/joost3d" rel="noopener noreferrer">
                    <Icon
                      style={{
                        fontSize: "3em",
                        cursor: "pointer",
                        margin: ".2em",
                      }}
                      className="tools"
                      type="twitter"
                      theme="outlined"
                    />
                  </a>
                  <a
                    target="_blank"
                    href="https://www.facebook.com/JoostTextures"
                    rel="noopener noreferrer"
                  >
                    <Icon
                      style={{
                        fontSize: "3em",
                        cursor: "pointer",
                        margin: ".2em",
                      }}
                      className="tools"
                      type="facebook"
                      theme="filled"
                    />
                  </a>
                </div>
              </Footer>
            </Row>
            {/* <Layout hasSider={true} style={{ minHeight: "100vh" }}> */}

            {/* <Breadcrumb style={{ margin: "16px 0" }}>
                    <Breadcrumb.Item>Home</Breadcrumb.Item>
                    <Breadcrumb.Item>List</Breadcrumb.Item>
                    <Breadcrumb.Item>App</Breadcrumb.Item>
                  </Breadcrumb> */}
          </div>
        </BrowserRouter>
      </div>
    );
  }
}

export default connect(
  null,
  { fetchUser }
)(App);

const Loading = () => <div />;

const Admin = Loadable({
  loader: () => import("./admin/Admin"),
  loading: Loading,
});
const TextureUpload = Loadable({
  loader: () => import("./textureUpload/TextureUpload"),
  loading: Loading,
});

const Account = Loadable({
  loader: () => import("./account/Account"),
  loading: Loading,
});



// WEBPACK FOOTER //
// ./src/components/App.js